import { render, staticRenderFns } from "./IntermediateHeader.vue?vue&type=template&id=152300f3&scoped=true&"
var script = {}
import style0 from "./IntermediateHeader.vue?vue&type=style&index=0&id=152300f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152300f3",
  null
  
)

export default component.exports